<mat-list-item (click)="onSummaryClick.emit()" (keydown.enter)="$event.target === $event.currentTarget && (onSummaryClick.emit())">
    <h4 matListItemLine data-testid="view-overlappig-events">
        View Overlapping Events
    </h4>
    <button mat-icon-button matListItemMeta>
        <img alt="Chevron Icon"
             class="overlapping-summary__chevron-icon"
             src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
    </button>
</mat-list-item>
